export interface DeepLinkConfig {
  iosAppId: string;
  androidPackage: string;
  fallbackUrl: string;
}

export const deepLinkConfig: DeepLinkConfig = {
  iosAppId: 'com.guider.guiderios',
  androidPackage: 'com.guider.guidermobile',
  fallbackUrl: 'https://theguiderapp.com'
};

export const detectMobileOS = (): 'ios' | 'android' | 'other' => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'ios';
  }

  if (/android/.test(userAgent)) {
    return 'android';
  }

  return 'other';
};

export const generateDeepLink = (path = ''): string => {
  const baseUrl = 'https://theguiderapp.com';
  return `${baseUrl}${path}`;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const generateAppLink = (path = ''): { ios: string; android: string } => {
  return {
    ios: `https://apps.apple.com/app/guider-the-app-for-muslims/id6446500974`,
    android: `https://play.google.com/store/apps/details?id=${deepLinkConfig.androidPackage}`
  };
};

export const attemptAppRedirect = (path = '', fallbackDelay = 2500): void => {
  const os = detectMobileOS();
  const appLinks = generateAppLink(path);

  if (os === 'ios') {
    // Try custom scheme to open the app using hidden iframe (avoids Safari error popup)
    const appScheme = `guider://${path.startsWith('/') ? path.slice(1) : path}`;
    const appStoreLink = appLinks.ios;

    // Create hidden iframe to attempt opening the app silently
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = appScheme;
    document.body.appendChild(iframe);

    // Clean up iframe after a moment
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);

    // Fallback to App Store if app doesn't open (only once)
    setTimeout(() => {
      // Only redirect if still on the page (app didn't open)
      if (!document.hidden) {
        window.location.href = appStoreLink;
      }
    }, fallbackDelay);
  } else if (os === 'android') {
    // Android intent URL has built-in fallback to Play Store
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    const intentUrl = `intent://${cleanPath}#Intent;scheme=guider;package=${
      deepLinkConfig.androidPackage
    };S.browser_fallback_url=${encodeURIComponent(appLinks.android)};end`;

    // Intent URL handles everything - opens app or redirects to store
    window.location.href = intentUrl;
  }
};

export const shouldShowAppBanner = (): boolean => {
  const os = detectMobileOS();
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isInApp = (window.navigator as any).standalone === true;

  // Hide banner during development/testing
  const isDev =
    window.location.hostname === 'localhost' || window.location.search.includes('hidebanner=true');

  return (os === 'ios' || os === 'android') && !isStandalone && !isInApp && !isDev;
};
